import React from 'react'
import Faq from '../pages/faq/Faq'

export default function LoginRoutes() {
    return <Faq />
}
